import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import useSpecialMenuCards from 'src/dispensary/hooks/use-special-menu-cards';
import useUI from 'hooks/use-ui';
import { useProductFiltersApplied } from 'hooks/use-product-filters-applied';

import { MobileOnly } from 'shared/components';
import Menu from 'components/menu';
import { OfferMenuSection } from 'components/offer-menu-section';
import SubcategoriesPills from 'components/subcategories-pills';
import ContentWrapper from 'components/core/content-wrapper';
import { useRemoteComponent, RemoteComponentSlot } from 'hooks/use-remote-component';

export function SpecialsPageContentLegacy() {
  const UI = useUI();
  const { dispensary } = useDispensary();

  const ListPageHero = useRemoteComponent(RemoteComponentSlot.ListPageHero);

  const { products, totalPages, loading } = useDispensaryProducts({ filters: { isOnSpecial: true } });

  const { specials } = useSpecialMenuCards();

  const productFiltersApplied = useProductFiltersApplied();
  const displaySidebar = !(_.isEmpty(products) && !productFiltersApplied);

  if (!dispensary) {
    return null;
  }

  return (
    <>
      <ListPageHero />
      <ContentWrapper>
        <OffersContainer>
          <OfferMenuSection UI={UI} dispensary={dispensary} specials={specials} />
        </OffersContainer>
        <MobileOnly>
          <PillContainer>
            <SubcategoriesPills isSpecials />
          </PillContainer>
        </MobileOnly>
        <Menu
          products={products}
          loading={loading}
          dispensary={dispensary}
          page='specials'
          totalPages={totalPages}
          displaySidebar={displaySidebar}
        />
      </ContentWrapper>
    </>
  );
}

const OffersContainer = styled.div`
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    h1 {
      padding-top: 44px;
      padding-left: 25px;
    }
  }
`;

const PillContainer = styled.div`
  overflow: auto;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    .subcategories-pills {
      margin-top: 36px;
    }
  }
`;
